import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule, NgIf} from '@angular/common';
import {FuseAlertComponent, FuseAlertType} from "../../../../@fuse/components/alert";
import {LoaderService} from "../../../_services/loader.service";
import {Router, RouterLink} from "@angular/router";
import {BaseRequestService} from "../../../_services/base.service";
import {MyToastrService} from "../../../_services/toastr.service";
import {HttpHeaders} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {DynamicFormComponent} from "../forms/dynamic-form/dynamic-form.component";
import {CommonService} from "../../../_services/common.service";
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'environments/environment';

@Component({
  selector: 'signup',
  standalone: true,
  imports: [RouterLink, NgIf, FuseAlertComponent, FormsModule,
        ReactiveFormsModule, MatFormFieldModule, MatInputModule,
        MatButtonModule, MatIconModule, MatCheckboxModule,
        MatProgressSpinnerModule, DynamicFormComponent],
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {
    @Input() signupConf: any;
    @Input() regions: any;
    @Output() saveCallback = new EventEmitter();
    @Output() cancelCallback = new EventEmitter();
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    alert: { type: FuseAlertType; message: string } = {
        type   : 'success',
        message: '',
    };
    showAlert: boolean = false;
    elementList: any;
    regionHash: any = {};
    isRun = false;
    cIndex = 0;
    messages: any = [
        'Creating your tenant',
        'Applying tenant security',
        'Configuring reports',
        'Configuring dashboards',
        'Making the system ready!'
    ];
    /**
     * Constructor
     */
    constructor(
        private _router: Router, private cs: CommonService,
        private loaderService: LoaderService, private _bs: BaseRequestService,
        private toast: MyToastrService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if (!this.signupConf.spanLayout) {
            this.signupConf.spanLayout = 1;
        }
        this.elementList = this.cs.processFormElements(this.signupConf.formElements);
        if (this.regions && this.regions.length) {
            this.regions.forEach((obj: any) => {
                this.regionHash[obj.name] = obj.value;
            });
        }
    }

    updateMsg(): void {
        if (this.isRun) {
            if (this.cIndex <= this.messages.length - 1) {
                if (this.cIndex) {
                    this.loaderService.display(false);
                }
                this.loaderService.display(true, this.messages[this.cIndex]);
                this.cIndex++;
                setTimeout(() => this.updateMsg(), 5000);
            }
        } else {
            this.loaderService.display(false);
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    signup($event: any): void {
        if (this.isRun) { return; }
        if (!this.signupConf.isComponentSide) {
            this.saveCallback.emit($event); return;
        }
        this.showAlert = false;
        if ($event.password.length < this.signupConf.passLength || $event.confirm_password.length < this.signupConf.passLength ) {
            this.showAlert = true; this.alert.type = 'error'; this.alert.message = `The minimum required length for a password is ${this.signupConf.passLength} characters.`;
            return;
        } else if ($event.password !== $event.confirm_password) {
            this.showAlert = true; this.alert.type = 'error'; this.alert.message = 'The password and the confirmation password do not match';
            return;
        }
        if ($event.tenant_name && $event.tenant_name.indexOf('_') > -1 || $event.tenant_name.indexOf('.') > -1) {
            this.showAlert = true; this.alert.type = 'error'; this.alert.message = 'The tenant name should not contain any special letters. Please use alpha numeric';
            return;
        }
        let httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'x-pod-id':   this.regionHash[$event['region']]
            })
        };
        const token = btoa(this.signupConf.token);
        if (!httpOptions.headers.has('AUTHORIZATION') && token) {
            httpOptions.headers = httpOptions.headers.append(
                'AUTHORIZATION',
                `Bearer ${token}`
            );
        }
        this.isRun = true;
        this.updateMsg();
        const data: any = {};
        this.signupConf.objectMapping.forEach((a: any) => {
            data[a.destination] = $event[a.source];
        });
        const postData = (this.signupConf.objectMapping && this.signupConf.objectMapping.length) ? data : $event;
        postData.tokenControl = $event.tokenControl;
        if(!environment.production){
            postData.region = 'ap-south-2';
        }
        this._bs.doRequest(this.signupConf.url, 'post', postData, null, httpOptions.headers)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((result: any) => {
           this.loaderService.display(false);
           this.isRun = false;
           if (result.status) {
               this.toast.sToast('success', 'Successfully created!');
               this.showAlert = true; this.alert.type = 'success'; this.alert.message = 'Successfully created!';
               this._router.navigateByUrl(`/success?tenant_name=${$event.tenant_name}`).then(r => console.log(r));
           } else {
               this.showAlert = true; this.alert.type = 'error'; this.alert.message = result.message;
           }
        }, (error: any) => {
            this.loaderService.display(false);
            this.isRun = false;
            this.showAlert = true; this.alert.type = 'error'; this.alert.message = error.message;
        });
    }

    login($event: any): void {
        if (!this.signupConf.isComponentSide) {
            this.cancelCallback.emit($event); return;
        }
        this._router.navigateByUrl(this.signupConf.redirectRouterLink).then(r => console.log(r));
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
